export default __webpack_public_path__ + "static/media/US_Hero7_2.fc936265.png";